import { createFileRoute } from '@tanstack/react-router'

// Bare /account/api (no client selected): the layout renders the client selector and this index match
// renders nothing below it. Selecting a client navigates to `/account/api/$appId`.
export const Route = createFileRoute('/_app/account/api/')({})
